import { Button, Text } from '@viapeople/components'
import type React from 'react'
import { useState } from 'react'

interface DeclinedReviewer {
	userId: string
	firstName: string
	lastName: string
	declineReason: string | null
	declinedAt: Date
}

interface DeclinedReviewersNoticeProps {
	declinedReviewers: DeclinedReviewer[]
}

export const DeclinedReviewersNotice: React.FC<DeclinedReviewersNoticeProps> = ({ declinedReviewers }) => {
	const [isExpanded, setIsExpanded] = useState(false)

	if (declinedReviewers.length === 0) {
		return null
	}

	return (
		<div className='bg-yellow-50 border border-yellow-200 rounded-md p-4 mb-4'>
			<div className='flex items-start gap-3'>
				<div className='flex-shrink-0'>
					<svg className='h-5 w-5 text-yellow-600' viewBox='0 0 20 20' fill='currentColor' aria-hidden='true'>
						<path
							fillRule='evenodd'
							d='M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z'
							clipRule='evenodd'
						/>
					</svg>
				</div>
				<div className='flex-1'>
					<div className='flex items-center justify-between'>
						<div>
							<Text variant='small' weight='semibold' className='text-yellow-800'>
								{declinedReviewers.length} {declinedReviewers.length === 1 ? 'Rater' : 'Raters'}
								Declined
							</Text>
							<Text variant='xsmall' className='text-yellow-700 mt-1'>
								{declinedReviewers.length === 1
									? 'One reviewer declined to provide feedback for this evaluation.'
									: `${declinedReviewers.length} reviewers declined to provide feedback for this evaluation.`}
							</Text>
						</div>
						<Button variant='secondary' size='small' onClick={() => setIsExpanded(!isExpanded)} className='ml-4'>
							{isExpanded ? 'Hide Details' : 'View Details'}
						</Button>
					</div>

					{isExpanded && (
						<div className='mt-4 space-y-3'>
							{declinedReviewers.map((reviewer) => (
								<div key={reviewer.userId} className='bg-white border border-yellow-100 rounded p-3'>
									<Text variant='small' weight='semibold' className='text-neutral-900'>
										{reviewer.firstName} {reviewer.lastName}
									</Text>
									<Text variant='xsmall' className='text-neutral-600 mt-1'>
										Declined on {new Date(reviewer.declinedAt).toLocaleDateString()}
									</Text>
									{reviewer.declineReason && (
										<div className='mt-2'>
											<Text variant='xsmall' className='text-neutral-500'>
												Reason:
											</Text>
											<Text variant='xsmall' className='text-neutral-700 mt-1'>
												{reviewer.declineReason}
											</Text>
										</div>
									)}
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
